import { ListTasks } from "~/components/admin/dispatch/task";
import PageMeta from "~/components/common/meta";

export const ScreenInternalEvents = () => {
  return (
    <>
      <PageMeta
        title="Internal Events | Art Handler"
        description="Internal Events"
      />
      <ListTasks />
    </>
  );
};
